export const LANDING = 'LANDING' as const;
export const LOGIN = 'LOGIN' as const;
export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION' as const;
export const PLATFORM_SELECTION = 'PLATFORM_SELECTION' as const;
export const REDEEM_SUCCESS = 'REDEEM_SUCCESS' as const;
export const ADDITIONAL_INFO = 'ADDITIONAL_INFO' as const;
export const ERROR_MESSAGE = 'ERROR_MESSAGE' as const;
export const ERROR_MESSAGE_GENERIC_ERROR = 'ERROR_MESSAGE_GENERIC_ERROR' as const;
export const ERROR_MESSAGE_NOT_ELIGIBLE = 'ERROR_MESSAGE_NOT_ELIGIBLE' as const;
export const ERROR_MESSAGE_CODE_ALREADY_REDEEMED = 'ERROR_MESSAGE_CODE_ALREADY_REDEEMED' as const;
export const ERROR_MESSAGE_USER_ALREADY_REDEEMED = 'ERROR_MESSAGE_USER_ALREADY_REDEEMED' as const;
export const ERROR_MESSAGE_INVALID_CODE = 'ERROR_MESSAGE_INVALID_CODE' as const;
export const ITEMS_DISPLAY_PAGE = 'ITEMS_DISPLAY_PAGE' as const;
export const ITEM_SELECTION_PAGE = 'ITEM_SELECTION_PAGE' as const;
export const ERROR_OWN_ALL_ITEMS = 'ERROR_OWN_ALL_ITEMS' as const;
export const ERROR_MAINTENANCE = 'ERROR_MAINTENANCE' as const;
